import React from 'react';

import { type VariantProps, tv } from 'tailwind-variants';

const errorMessageVariants = tv({
  slots: {
    base: 'text-red-110',
  },
  variants: {
    size: {
      small: {
        base: 'text-sm',
      },
      medium: {
        base: 'text-base',
      },
      large: {
        base: 'text-lg',
      },
    },
  },
  defaultVariants: {
    size: 'small',
  },
});

type ErrorMessageProps = Omit<React.ComponentProps<'span'>, 'className'> &
  VariantProps<typeof errorMessageVariants>;

const ErrorMessage = ({ children, size, ...props }: ErrorMessageProps) => {
  const style = errorMessageVariants({ size });

  return (
    <span className={style.base()} {...props}>
      {children}
    </span>
  );
};

export default ErrorMessage;
